import { Content, ApplicationEditLayout } from "core/layouts";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
    BaasicButton,
    BasicInput,
    BaasicFieldDropdown,
    DatePickerField,
} from "core/components";
import { defaultTemplate } from "core/hoc";

class WoundOrderEditWoundDetailsTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            selectedValue: null,
        };
    }

    render() {
        const { woundOrderEditWoundDetailsViewStore } = this.props;
        const {
            contentLoading,
            selectedPressureStageTabItemAbrv,
            setSelectedTabItem,
            pressureStageTabItems,
            modificationTypeItems,
            form,
            selectedModificationTypeTabItemAbrv,
            woundDepthTabItems,
            selectedWoundDepthTabItemAbrv,
            tunellingRadioValue,
            underminingRadioValue,
            selectedExudateTypeTabItemAbrv,
            diagnosisCodeStore,
            thicknessTypeItems,
            selectedThicknessTypeTabItemAbrv,
            stageOtherTabItems,
            selectedStageThicknessTypeTabItemAbrv,
            depthUnknownTypeItems,
            selectedDepthUnknownTypeTabItemAbrv,
            debridementTypeItems,
            selectedDebridementTypeTabItemAbrv,
            exudateTypeItems,
        } = woundOrderEditWoundDetailsViewStore;

        const exudateTypeButtons = exudateTypeItems
            ? exudateTypeItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedExudateTypeTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedExudateTypeTabItemAbrv
                              ? setSelectedTabItem(
                                    "exudateType",
                                    item.abrv,
                                    item.id
                                )
                              : {}
                      }
                  />
              ))
            : null;

        const debridementTypeButtons = debridementTypeItems
            ? debridementTypeItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedDebridementTypeTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedDebridementTypeTabItemAbrv
                              ? setSelectedTabItem(
                                    "debridementType",
                                    item.abrv,
                                    item.id
                                )
                              : {}
                      }
                  />
              ))
            : null;

        const depthUnknownTypeButtons = depthUnknownTypeItems
            ? depthUnknownTypeItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedDepthUnknownTypeTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedDepthUnknownTypeTabItemAbrv
                              ? setSelectedTabItem(
                                    "depthUnknownType",
                                    item.abrv,
                                    item.id
                                )
                              : {}
                      }
                  />
              ))
            : null;

        const thicknessTypeTabButtons = thicknessTypeItems
            ? thicknessTypeItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedThicknessTypeTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedThicknessTypeTabItemAbrv
                              ? setSelectedTabItem(
                                    "thicknessType",
                                    item.abrv,
                                    item.id
                                )
                              : {}
                      }
                  />
              ))
            : null;

        const stageTabButtons = pressureStageTabItems
            ? pressureStageTabItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedPressureStageTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedPressureStageTabItemAbrv
                              ? setSelectedTabItem(
                                    "pressureStage",
                                    item.abrv,
                                    item.id
                                )
                              : {}
                      }
                  />
              ))
            : null;

        const modificationTabButtons = modificationTypeItems
            ? modificationTypeItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedModificationTypeTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedModificationTypeTabItemAbrv
                              ? setSelectedTabItem(
                                    "modificationType",
                                    item.abrv,
                                    item.id
                                )
                              : {}
                      }
                  />
              ))
            : null;

        const woundDepthTabButtons = woundDepthTabItems
            ? woundDepthTabItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedWoundDepthTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedWoundDepthTabItemAbrv
                              ? setSelectedTabItem("woundDepthType", item.abrv)
                              : {}
                      }
                  />
              ))
            : null;

        const stageOtherTabButtons = stageOtherTabItems
            ? stageOtherTabItems.map((item) => (
                  <BaasicButton
                      key={item.abrv}
                      className={
                          "btn--toggle btn--base " +
                          (item.abrv == selectedStageThicknessTypeTabItemAbrv
                              ? "active"
                              : "")
                      }
                      label={item.name}
                      onClick={() =>
                          item.abrv != selectedStageThicknessTypeTabItemAbrv
                              ? setSelectedTabItem(
                                    "stageThicknessType",
                                    item.abrv
                                )
                              : {}
                      }
                  />
              ))
            : null;

        return (
            <ApplicationEditLayout store={woundOrderEditWoundDetailsViewStore}>
                <div className="card card--form card--primary card--med">
                    <Content loading={contentLoading}>
                        <div className="grid--wound">
                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Location
                                </div>
                                <div className="grid--wound__sub">
                                    <BasicInput
                                        field={form.$("location")}
                                        showLabel={false}
                                    />
                                </div>
                            </div>

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Etiology
                                </div>
                                <div className="grid--wound__sub">
                                    {stageOtherTabButtons}
                                </div>
                            </div>

                            {selectedStageThicknessTypeTabItemAbrv ===
                                "stage" && (
                                <div className="grid--wound__item">
                                    <div className="grid--wound__label">
                                        Stage
                                    </div>
                                    <div className="grid--wound__sub">
                                        {stageTabButtons}
                                    </div>
                                </div>
                            )}

                            {selectedStageThicknessTypeTabItemAbrv ===
                                "other" && (
                                <div className="grid--wound__item">
                                    <div className="grid--wound__label">
                                        Thickness Type
                                    </div>
                                    <div className="grid--wound__sub">
                                        {thicknessTypeTabButtons}
                                        <BasicInput
                                            field={form.$(
                                                "etiologyOtherDescription"
                                            )}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Was the wound debrided or surgically
                                    created/modified?
                                </div>
                                <div className="grid--wound__sub">
                                    {modificationTabButtons}
                                </div>
                            </div>

                            {selectedModificationTypeTabItemAbrv ==
                                "debrided" && (
                                <div>
                                    <div className="grid--wound__item">
                                        <div className="grid--wound__label">
                                            Debridement Type
                                        </div>
                                        <div className="grid--wound__sub">
                                            {debridementTypeButtons}
                                        </div>
                                    </div>

                                    <div className="grid--wound__item">
                                        <div className="grid--wound__label">
                                            Date of debridement
                                        </div>
                                        <div className="grid--wound__sub">
                                            <DatePickerField
                                                field={form.$(
                                                    "debridementDate"
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Measurements
                                </div>
                                <div className="grid--wound__sub">
                                    <div>
                                        <BasicInput field={form.$("length")} />
                                    </div>
                                    <div>
                                        <BasicInput field={form.$("width")} />
                                    </div>
                                </div>
                            </div>
                            <div className="grid--wound__item">
                                <div className="grid--wound__label">Depth</div>
                                <div className="grid--wound__sub">
                                    {woundDepthTabButtons}
                                </div>
                            </div>

                            {selectedWoundDepthTabItemAbrv ==
                                "unable-to-determine" && (
                                <div className="grid--wound__item">
                                    <div className="grid--wound__label">
                                        Depth Unknown Type
                                    </div>
                                    <div className="grid--wound__sub">
                                        {depthUnknownTypeButtons}
                                    </div>
                                </div>
                            )}
                            {selectedWoundDepthTabItemAbrv == "fill-in" && (
                                <div className="grid--wound__item">
                                    <div className="grid--wound__label"></div>
                                    <div className="grid--wound__sub">
                                        <div>
                                            <BasicInput
                                                field={form.$("depth")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Tunneling?
                                </div>
                                <div className="grid--wound__sub">
                                    <BaasicButton
                                        className={
                                            "btn--toggle btn--base " +
                                            (tunellingRadioValue.value === true
                                                ? "active"
                                                : "")
                                        }
                                        label="Yes"
                                        onClick={() =>
                                            (tunellingRadioValue.value = true)
                                        }
                                    />
                                    <BaasicButton
                                        className={
                                            "btn--toggle btn--base " +
                                            (tunellingRadioValue.value === false
                                                ? "active"
                                                : "")
                                        }
                                        label="No"
                                        onClick={() =>
                                            (tunellingRadioValue.value = false)
                                        }
                                    />
                                </div>
                            </div>
                            {tunellingRadioValue.value === true && (
                                <div className="grid--wound__item">
                                    <div className="grid--wound__label"></div>
                                    <div className="grid--wound__sub">
                                        <div>
                                            <BasicInput
                                                field={form.$("tunnelingSize")}
                                            />
                                        </div>
                                        <div>
                                            <BasicInput
                                                field={form.$(
                                                    "tunnelingPosition"
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Undermining?
                                </div>
                                <div className="grid--wound__sub">
                                    <BaasicButton
                                        className={
                                            "btn--toggle btn--base " +
                                            (underminingRadioValue.value ===
                                            true
                                                ? "active"
                                                : "")
                                        }
                                        label="Yes"
                                        onClick={() =>
                                            (underminingRadioValue.value = true)
                                        }
                                    />
                                    <BaasicButton
                                        className={
                                            "btn--toggle btn--base " +
                                            (underminingRadioValue.value ===
                                            false
                                                ? "active"
                                                : "")
                                        }
                                        label="No"
                                        onClick={() =>
                                            (underminingRadioValue.value = false)
                                        }
                                    />
                                </div>
                            </div>

                            {underminingRadioValue.value === true && (
                                <div className="grid--wound__item">
                                    <div className="grid--wound__label"></div>
                                    <div className="grid--wound__sub">
                                        <div>
                                            <BasicInput
                                                field={form.$(
                                                    "underminingSize"
                                                )}
                                            />
                                        </div>
                                        <div>
                                            <BasicInput
                                                field={form.$(
                                                    "underminingStartPosition"
                                                )}
                                            />
                                        </div>
                                        <div>
                                            <BasicInput
                                                field={form.$(
                                                    "underminingEndPosition"
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Exudate Type
                                </div>
                                <div className="grid--wound__sub is-dd">
                                    {exudateTypeButtons}
                                </div>
                            </div>

                            <div className="grid--wound__item">
                                <div className="grid--wound__label">
                                    Diagnosis Codes
                                </div>
                                <div className="grid--wound__sub is-dd">
                                    <BaasicFieldDropdown
                                        field={form.$("diagnosisCodes")}
                                        store={diagnosisCodeStore}
                                    />
                                </div>
                            </div>
                        </div>
                    </Content>
                </div>
            </ApplicationEditLayout>
        );
    }
}

WoundOrderEditWoundDetailsTemplate.propTypes = {
    woundOrderEditWoundDetailsViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(WoundOrderEditWoundDetailsTemplate);
